export const {
  REACT_APP_API_URL,
  REACT_APP_BASE_BACKEND_URL,
  REACT_APP_MAX_FILE_SIZE_UPLOAD,
  REACT_APP_TIMEZONE,
  REACT_APP_TABLE_ROWS,
} = process.env;
